module.exports = __webpack_public_path__ + "img/logo-dark.4c556d30.svg";